(function (Global, $) {
    /**
     * Store class
     *
     * @param {any} params Paramètres à l'initialisation
     * @param {string} params.name Nom du Store
     * @param {any} params.state Object state à l'initialisation
     * @param {any} params.actions Liste des actions qui modifie le state
     * @example
     * var store = new Store({
     *   name: 'ExampleStore',
     *   state: {
     *      n: 0
     *   },
     *   actions: {
     *      count: function(state) {
     *          state.set('n', state.get('n') + 1)
     *      }
     *   }
     * })
     *
     * store.events.subscribe(function(state) {
     *   console.log('State n: ' + state.n)
     * })
     *
     * setInterval(function() {
     *   store.dispatch('count')
     * }, 3000)
     */
    var Store = function (params) {
        if (!params.hasOwnProperty("name")) {
            console.error("A Store must have name");
            return;
        }

        this._state = params.state || {};
        
        this.actions = params.actions || {};
        this.name = params.name;
        this.events = $.Topic(this.name);
        this.state = new State(this._state, this.events);
    };

    Store.prototype.dispatch = function (actionKey, payload) {
        var self = this;

        if (typeof self.actions[actionKey] !== "function") {
            console.error('Action "' + actionKey + "\" doesn't exist.");
            return false;
        }
        self.actions[actionKey](self.state, payload);

        return true;
    };

    var State = function (state, events) {
        this._state = state;
        this._events = events;
    };

    State.prototype.set = function () {
        if (arguments.length === 2) {
            this._state[arguments[0]] = arguments[1];
        } else {
            this._state = arguments[0];
        }
        this._events.publish(this._state);
    };

    State.prototype.get = function (key) {
        return this._state[key];
    };

    State.prototype.getAll = function () {
        return this._state;
    };

    Global.Store = Store;
})(window, jQuery);
